import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { jckRoutes } from './_jck';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(jckRoutes)
  ]
})
export class JckModule { }
